import React from 'react';
import { makeStyles } from '~/lib/bn-material-ui';
import { useStateValue } from './data/order-calculator-context';

const useStyles = makeStyles((theme) => {
  const borderWidth = '1';
  const negativeBorderPx = `-${borderWidth}px`;
  const absoluteStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  };

  return {
    order: {
      cursor: 'pointer',
      pointerEvents: 'all',
      '&:hover > div': {
        background: theme.palette.blue[10],
        opacity: 0.5,
      },
      '&:hover > span': {
        borderColor: `${theme.palette.blue[40]}`,
      },
    },
    background: {
      ...absoluteStyle,
      zIndex: 1,
      cursor: 'pointer',
      pointerEvents: 'all',
    },
    border: {
      position: 'absolute',
      border: `${borderWidth}px solid ${theme.palette.gray[60]}`,
      top: negativeBorderPx,
      right: negativeBorderPx,
      bottom: negativeBorderPx,
      left: negativeBorderPx,
      zIndex: 4,
    },
  };
});

export default function BinOrder({ date }) {
  const styles = useStyles();
  const [{ orders }, dispatch] = useStateValue();

  if (!orders) {
    return null;
  }

  const daysOrders = orders[date];

  // hide cancelled orders from calendar view
  if (!daysOrders) {
    return null;
  }

  const select = () => dispatch({ type: 'selectOrder', activeOrderId: daysOrders[0].getLinkByRel('self').href });

  return (
    <div
      className={styles.order}
      role='button'
      tabIndex='-1'
      onClick={select}
    >
      <div className={styles.background} />
      <span className={styles.border} />
    </div>
  );
}
